import { createContext } from 'react';

export type MainContentSurface = 'default' | 'external';

export type MainContentSurfaceContextValue = {
  setSurface: (surface: MainContentSurface) => void;
};

/**
 * Управление фоном/обводкой `main` в MainLayout: «внешние» страницы поднимают `external`
 * через {@link ExternalPageCanvas}.
 */
export const MainContentSurfaceContext = createContext<MainContentSurfaceContextValue | null>(
  null,
);
